import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=fa963248&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=fa963248&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa963248",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa963248')) {
      api.createRecord('fa963248', component.options)
    } else {
      api.reload('fa963248', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=fa963248&scoped=true&", function () {
      api.rerender('fa963248', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bcd0yu2ryi1i/JS/comp/SearchFilterTokens.vue"
export default component.exports